"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildDisputeCreatedCustomerMockData = void 0;
const email_theme_tokens_1 = require("../../helpers/email-theme-tokens");
const locales_1 = require("../../internationalization/enums/locales");
const locales_2 = require("../../internationalization/features/locales");
const email_templates_1 = require("../../internationalization/locales/email-templates");
const icons_1 = require("../icons");
const organization_facing_base_1 = require("./organization-facing-base");
const DISPUTE_CREATED_CUSTOMER_SUBJECT = (0, locales_2.buildLocaleRecord)({
    [locales_1.Locales.EN]: "You have disputed a payment",
    [locales_1.Locales.FR]: "Vous avez contesté un paiement",
    [locales_1.Locales.ES]: "Ha disputado un pago",
    [locales_1.Locales.DE]: "Sie haben eine Zahlung angefochten",
});
const buildDisputeCreatedCustomerMockData = ({ organizationName, color, isDarkMode, locale = "en", subject = (0, organization_facing_base_1.pickForLocale)(DISPUTE_CREATED_CUSTOMER_SUBJECT, locale), fullName = "Jane Donor", description = "Donation to Bright Futures Foundation", amount = "$120.00", date = "March 14, 2026 at 9:00 AM", }) => {
    const theme = (0, email_theme_tokens_1.resolveEmailThemeTokens)(color || "#FFFFFF", isDarkMode ? "dark" : "light");
    return {
        theme,
        iconZeffyLogo: theme.zeffyLogoVariant === "dark" ? icons_1.EMAIL_ICON_DATA_URI.zeffyDark : icons_1.EMAIL_ICON_DATA_URI.zeffyLight,
        labels: (0, email_templates_1.getEmailLabels)(locale),
        lang: locale,
        subject,
        organizationName: (organizationName || "Bright Futures Foundation").toUpperCase(),
        fullName,
        description,
        amount,
        date,
    };
};
exports.buildDisputeCreatedCustomerMockData = buildDisputeCreatedCustomerMockData;
